<template>
<m-pageframe
    :title="title"
>
<v-container
    fluid
    v-if="params != null"
>
    <div
        class="outer_container"
    >

        <div
            class="left_pane"
        >
            <v-btn
                color="primary"
                outlined
                class="mb-4"
                @click="onClickGoBack"
            >
                <v-icon left>mdi-arrow-left</v-icon>
                Back to Lightboxes
            </v-btn>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-cog</v-icon>
                        Basic Settings
                    </div>
                    <m-edit-text
                        label="Lightbox Label"
                        v-model="params.label"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-palette</v-icon>
                        Appearance & Styling
                    </div>
                    <m-edit-css
                        label="Background Blur"
                        v-model="params.background_blur.style"
                        :default_value="params.background_blur.default_style"
                        v-on:input="onChange"
                    />

                    <m-edit-css
                        label="Lightbox Container"
                        v-model="params.container.style"
                        :default_value="params.container.default_style"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-format-header-1</v-icon>
                        Header Content
                    </div>
                    <m-edit-styled-text
                        label="Banner Text"
                        v-model="params.banner_text"
                        v-on:input="onChange"
                        hint="This text will show when use logo is unchecked or no logo is available"
                    />

                    <m-edit-organization-logo
                        v-model="params.logo_image.url"
                        v-on:input="onChange"
                    />

                    <v-checkbox
                        label="Use Logo"
                        class="mt-n2"
                        v-model="params.use_logo"
                        v-on:change="onChange"
                    />

                    <m-edit-css
                        label="Logo Image"
                        v-model="params.logo_image.style"
                        :default_value="params.logo_image.default_style"
                        v-on:input="onChange"
                    />

                    <m-edit-css
                        label="Header Background"
                        v-model="params.header_background.style"
                        :default_value="params.header_background.default_style"
                        v-on:input="onChange"
                    />

                    <m-edit-css
                        label="Close Icon"
                        v-model="params.close_icon.style"
                        :default_value="params.close_icon.default_style"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-text</v-icon>
                        Form Content
                    </div>
                    <m-edit-styled-text
                        label="Line 1"
                        v-model="params.line_1"
                        v-on:input="onChange"
                    />

                    <m-edit-styled-text
                        label="Line 2"
                        v-model="params.line_2"
                        v-on:input="onChange"
                    />

                    <m-edit-styled-text
                        label="Line 3"
                        v-model="params.line_3"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-form-textbox</v-icon>
                        Form Fields
                    </div>
                    <v-select
                        label="First Name"
                        v-model="params.first_name.field_mode"
                        :items="$rc.enumChoices('styled_field_mode',false)"
                        v-on:input="onChange"
                    />

                    <v-select
                        label="Last Name"
                        v-model="params.last_name.field_mode"
                        :items="$rc.enumChoices('styled_field_mode',false)"
                        v-on:input="onChange"
                    />

                    <v-select
                        label="Birthday"
                        v-model="params.birthday.field_mode"
                        :items="getBirthdayFieldModeChoices()"
                        v-on:input="onChange"
                    />

                    <v-select
                        label="Email Address"
                        v-model="params.email_address.field_mode"
                        :items="$rc.enumChoices('styled_field_mode',false)"
                        v-on:input="onChange"
                    />

                    <v-select
                        label="Phone Number"
                        v-model="params.phone_number.field_mode"
                        :items="$rc.enumChoices('styled_field_mode',false)"
                        v-on:input="onChange"
                    />

                    <m-edit-styled-text
                        label="Agreement"
                        v-model="params.agreement"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-send</v-icon>
                        Submit Button
                    </div>
                    <m-edit-css
                        label="Send Button"
                        v-model="params.send_button.style"
                        :default_value="params.send_button.default_style"
                        v-on:input="onChange"
                    />

                    <m-edit-styled-text
                        label="Send Button Text"
                        v-model="params.send_button_text"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-check-circle</v-icon>
                        Thank You Page
                    </div>
                    <m-edit-styled-text
                        label="Thank You Line 1"
                        v-model="params.thank_you_line_1"
                        v-on:input="onChange"
                    />

                    <m-edit-styled-text
                        label="Thank You Line 2"
                        v-model="params.thank_you_line_2"
                        v-on:input="onChange"
                    />

                    <m-edit-styled-text
                        label="Thank You Button Text"
                        v-model="params.thank_you_button_text"
                        v-on:input="onChange"
                    />

                    <m-edit-css
                        label="Thank You Button"
                        v-model="params.thank_you_button.style"
                        :default_value="params.thank_you_button.default_style"
                        v-on:input="onChange"
                    />
                </v-card-text>
            </v-card>


            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-message-text</v-icon>
                        Messaging Settings
                    </div>
                    <m-edit-select-organization-owned-endpoint
                        :organization_id="$route.params.organization_id"
                        v-model="params.endpoint_double_opt_in"
                        v-on:input="onChange"
                        label="Send double opt-in message from"
                        include_bot_numbers
                    />

                    <m-edit-message-patterns-compact
                        class="mb-6"
                        label="Double opt-in message"
                        v-model="params.double_opt_in_message_patterns"
                        context="form-after-submit"
                        v-on:input="onChange"
                        :default_value="getDefaultDoubleOptInMessagePatterns()"
                    />

                    <m-edit-message-patterns-compact
                        class="mb-6"
                        label="After double opt-in message"
                        v-model="params.after_double_opt_in_message_patterns"
                        context="form-after-submit"
                        v-on:input="onChange"
                        :default_value="getDefaultAfterDoubleOptInMessagePatterns()"
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-sync-circle</v-icon>
                        CRM Integration Settings
                    </div>
                    <v-alert
                        border="left"
                        colored-border
                        type="info"
                        elevation="2"
                        class="mb-4"
                    >
                        <span v-if="!crm_integration_available">
                            Your account currently does not have any compatible CRM integrations enabled to allow for syncing submissions. 
                        </span>
                        <span v-else-if="$rc.getEnvironment() == 'dev'">
                            You are in the development environment. All submissions, including previews, can sync to your CRM.
                        </span>
                        <span v-else>
                            For your safety, syncing is always disabled for previews to avoid sending test data to your CRM. Live submissions from your website will continue to sync per your CRM integration settings below.
                        </span>
                    </v-alert>

                    <m-edit-select-enum
                        label="On Form Submission"
                        enum_name="crm_customer_upsert_mode"
                        v-model="params.on_submit_crm_customer_upsert_mode"
                        v-on:input="onChange"
                        :read_only="!crm_integration_available"
                        :option_descriptions="crm_upsert_mode_descriptions"
                        hint="Action to take in your CRM when a customer submits the form."
                    />

                    <m-edit-select-enum
                        label="After Double Opt-In"
                        enum_name="crm_customer_upsert_mode"
                        v-model="params.after_double_opt_in_crm_customer_upsert_mode"
                        v-on:input="onChange"
                        :read_only="!crm_integration_available"
                        :option_descriptions="crm_upsert_mode_descriptions"
                        hint="Action to take in your CRM after a customer confirms their subscription."
                    />
                </v-card-text>
            </v-card>

            <v-card outlined class="mb-3">
                <v-card-text class="pa-3">
                    <div class="subtitle-1 font-weight-medium mb-3">
                        <v-icon left color="primary">mdi-eye</v-icon>
                        Preview Controls
                    </div>
                    <v-row>
                        <v-col cols="12" md="6">
                            <v-subheader class="px-0">
                                Lightbox Actions
                            </v-subheader>
                            <v-btn-toggle
                                mandatory
                                class="d-flex"
                                color="primary"
                            >
                                <v-btn
                                    v-on:click="onClickShowLightbox"
                                    class="flex-grow-1"
                                >
                                    <v-icon left>mdi-eye</v-icon>
                                    Show
                                </v-btn>
                                <v-btn
                                    v-on:click="onClickHideLightbox"
                                    class="flex-grow-1"
                                >
                                    <v-icon left>mdi-eye-off</v-icon>
                                    Hide
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-subheader class="px-0">
                                Preview Mode
                            </v-subheader>
                            <v-btn-toggle
                                v-model="preview_mode"
                                mandatory
                                color="primary"
                                class="d-flex"
                            >
                                <v-btn value="desktop" class="flex-grow-1">
                                    <v-icon left>mdi-monitor</v-icon>
                                    Desktop
                                </v-btn>
                                <v-btn value="mobile" class="flex-grow-1">
                                    <v-icon left>mdi-cellphone</v-icon>
                                    Mobile
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>






           <!--<v-divider
                style="margin-top: 15px; margin-bottom: 15px"
           />

            <div
                style="margin-top: 15px"
            >
                <pre>{{ JSON.stringify(params, null, 2) }}</pre>
            </div>-->

        </div>

        <div
            class="right_pane_container"
            :class="{ 'mobile-preview': preview_mode === 'mobile' }"
        >
            <div class="iframe-wrapper" :class="{ 'mobile-frame': preview_mode === 'mobile' }">
                <iframe
                    class="right_pane_iframe"
                    :src="iframe_src_url"
                    ref="lightbox-iframe"
                />
            </div>
        </div>

       
           
    </div>


</v-container>
</m-pageframe>
</template>

<script>
import mEditCss from '../../components/input/m-edit-css.vue';

// LOGO URL: Pur Noire: https://files.redchirp.com/yrvatevqbrbeuxaaaayfdqzqbbqztfww.png
// LOGO URL: Barrel Creek: https://files.redchirp.com/cvctraabvftrufcaytwyyqyruxuzryzt.png

const _ = require('lodash');

export default {
  components: { mEditCss },

    data() {
        return {
            params: null,
            organization_lightboxes: null,
            first_load: true,
            crm_integration_available: false,
            preview_mode: 'desktop', // 'desktop' or 'mobile'
        }
    },

    mounted () {
        this.loadSettings();
        this.loadOrganizationLightboxes();
        this.checkCrmIntegrationAvailable();
        this.$rc.loadCustomFonts(this.$route.params.organization_id);
        window.addEventListener('message', this.onMessage, false);
    },

    unmounted () {
        window.removeEventListener('message', this.onMessage);
    },

    methods: {
        onMessage(event)
        {
            if ( event == null || event.data == null || !Array.isArray(event.data) || event.data.length <= 0 )
                return;

            let message_type = event.data[0];

            if ( message_type == 'redchirp-lightbox-ready' )
            {
                if ( this.params != null )
                {
                    this.sendMessage('redchirp-lightbox-show');
                }
            }
        },

        loadSettings()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET: /api/v1/lightbox/settings/:organization_id/:lightbox_id',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'lightbox_id': this.$route.params.lightbox_id,
                    },
            
                'on_success': (data) => {
                        this.params = _.cloneDeep(data);

                        if ( this.first_load )
                        {
                            this.first_load = false;

                            window.setTimeout(() => this.sendMessage('redchirp-lightbox-show'), 1000);
                        }
                        else
                        {
                            this.sendMessage('redchirp-lightbox-set-settings');
                        }
                    },
            
                'on_error': 'Unable to load lightbox settings',
            });
        },

        sendMessage(message_type)
        {
            if ( this.params == null )
                return;

            let iframe = this.$refs['lightbox-iframe'];

            if ( iframe == null )
                return;

            this.params.is_test_submission = true;

            let message =  [message_type];

            if ( message_type == 'redchirp-lightbox-set-settings' || message_type == 'redchirp-lightbox-show' )
                message.push(this.params);
            
            iframe.contentWindow.postMessage(
                message, 
                '*'
            );
        },


        loadOrganizationLightboxes()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'GET:/api/v1/lightbox/organization/:organization_id',

                'params' : {
                        'organization_id': this.$route.params.organization_id,
                    },

                'on_success': (data) => {
                        this.organization_lightboxes = _.cloneDeep(data);
                    },

                'on_error': 'Unable to load organization lightbox data',
            });
        },

        onClickShowLightbox()
        {
           this.sendMessage('redchirp-lightbox-show')
        },

        onClickHideLightbox() 
        {
           this.sendMessage('redchirp-lightbox-hide')
        },

        onChange: _.debounce(function() {
            this.doSaveSettings();
        }, 750),

        doSaveSettings()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'PUT: /api/v1/lightbox/settings',

                'params' : this.params,

                'on_success': (data) => {
                        this.params = data;
                        this.sendMessage('redchirp-lightbox-set-settings');
                    },

                'on_error': 'Unable to save lightbox settings',
            });
        },

     

        onClickGoBack()
        {
            this.$router.push({
                'name': 'lightbox-search-settings',
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                }
            });
        },

        checkCrmIntegrationAvailable()
        {
            this.$rc.hasEnabledIntegrationFeature(
                'customers-auto-enrich-from-lightbox-submission',
                (is_supported) => {
                    this.crm_integration_available = is_supported;
                },
                (error) => {
                    this.crm_integration_available = false;
                }
            );
        },
        
        getDefaultDoubleOptInMessagePatterns()
        {
            if ( this.organization_lightboxes && this.organization_lightboxes.default_double_opt_in_message)
                return [this.organization_lightboxes.default_double_opt_in_message];

            return [];
        },

        getDefaultAfterDoubleOptInMessagePatterns()
        {
            if ( this.organization_lightboxes && this.organization_lightboxes.default_after_double_opt_in_message)
                return [this.organization_lightboxes.default_after_double_opt_in_message];

            return [];
        },

        getBirthdayFieldModeChoices()
        {
            let choices = this.$rc.enumChoices('styled_field_mode', false);
            // For wine organizations, birthday field cannot be hidden or optional
            if (this.organization_lightboxes && this.organization_lightboxes.comp_organization_industry === 'wine')
            {
                choices = choices.filter(choice => choice.value !== 'hidden' && choice.value !== 'optional');
                this.params.birthday.field_mode = 'required';
            }
    
            return choices;
        },


    },

    computed: {
        iframe_src_url() {
            if ( this.$rc.getEnvironment() == 'dev' )
                return 'http://localhost:5173/index.html';

            if ( this.$rc.getEnvironment() == 'staging' )
                return 'https://files.redchirp.com/v1/prod/widget/staging-lightbox.html';

            return 'https://files.redchirp.com/v1/prod/widget/lightbox.html';
        },

        title()
        {
            if ( this.params == null )
                return 'Edit Lightbox';

            return this.params.label;
        },


        crm_upsert_mode_descriptions()
        {
            return {
                'do-nothing': 'No customer information will be sent to your CRM system. Use this if you want to collect contact information but handle CRM updates manually.',
                'create-only': 'Only create new customer records in your CRM when someone submits the form. If the customer already exists in your CRM, their information will not be updated.',
                'update-only': 'Only update existing customer records in your CRM. If someone submits the form but is not already a customer in your CRM, no new record will be created. This is useful for updating information for known customers only.',
                'create-or-update': 'Automatically create new customer records for new contacts and update existing records for known customers. This provides full synchronization between form submissions and your CRM system.'
            };
        },


    },

}
</script>

<style lang="scss" scoped>
.outer_container
{
    display: flex;

    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    right: 15px;
    gap: 10px;
}

.left_pane
{
    flex-grow: 1; 
    overflow-x: hidden; 
    overflow-y: auto;
    padding-right: 15px; 
    padding-bottom: 15px;
    min-width: 50%;
    max-width: 600px;
}

.right_pane_container
{
    flex-grow: 1;

    overflow-x: hidden;
    overflow-y: hidden;

    background-image: url('https://files.redchirp.com/644eb29a-b21a-49fc-892a-32dbaad6531a.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;

    display: flex;
    justify-content: center;
    align-items: center;
}

/* Mobile preview keeps same background but with black frame around it */
.right_pane_container.mobile-preview
{
    background: #ffffff;
    overflow-x: auto;
    overflow-y: auto;
    align-items: flex-start;
    padding: 20px;
}

/* Background is now handled by ::before pseudo-element */

.iframe-wrapper
{
    width: 100%;
    height: 100%;
    position: relative;
}

.iframe-wrapper.mobile-frame
{
    width: 390px;
    height: 844px;
    border: 8px solid #1a1a1a;
    border-radius: 40px;
    box-shadow:
        0 0 0 2px #333,
        0 8px 32px rgba(0,0,0,0.4),
        inset 0 0 0 1px #444;
    background: #000;
    padding: 20px 12px;
    position: relative;
    overflow: hidden;
}

/* Phone frame details */
.iframe-wrapper.mobile-frame::after
{
    content: '';
    position: absolute;
    top: 12px;
    left: 50%;
    transform: translateX(-50%);
    width: 120px;
    height: 6px;
    background: #333;
    border-radius: 3px;
    z-index: 3;
}

/* Inner screen area with tree background */
.iframe-wrapper.mobile-frame::before
{
    content: '';
    position: absolute;
    top: 20px;
    left: 12px;
    right: 12px;
    bottom: 20px;
    background-image: url('https://files.redchirp.com/644eb29a-b21a-49fc-892a-32dbaad6531a.jpg');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 24px;
    z-index: 1;
}

.right_pane_iframe
{
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: hidden;
    border: none;
    position: relative;
    z-index: 2; /* Ensure lightbox appears above background */
}

.mobile-frame .right_pane_iframe
{
    border-radius: 24px;
    position: relative;
    z-index: 2; /* Ensure iframe appears above background */
}

.mobile-label
{
    position: absolute;
    bottom: -30px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(0,0,0,0.8);
    color: white;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    white-space: nowrap;
}


@media only screen and (max-width: 920px)
{
    .right_pane_container{
        display: none;
    }

    .left_pane {
        max-width: none;
    }
}

/* Adjust mobile preview for smaller screens */
@media only screen and (max-width: 1200px)
{
    .iframe-wrapper.mobile-frame
    {
        width: 390px;
        height: 844px;
    }
}

.section-header {
    margin-top: 24px;
    margin-bottom: 6px;
    font-weight: bold;
    display: flex;
    align-items: center;
}


</style>